

const types = {
    SET_IMAGE_MODAL: "SET_IMAGE_MODAL",
    CHANGE_MODAL_REQUEST_CREDIT: "CHANGE_MODAL_REQUEST_CREDIT",
    SET_TYPE_CREDIT: "SET_TYPE_CREDIT",
};

const state = {
    imagen: true,
    modal_credit: false,
    type: "",
};

const actions = {
    setModalImagen({ commit }, data) {
        commit(types.SET_IMAGE_MODAL, data);
    },    
    setModalCredit({ commit }, data) {
        commit(types.CHANGE_MODAL_REQUEST_CREDIT, data);
    },    
    setTypeCredit({ commit }, data) {
        commit(types.SET_TYPE_CREDIT, data);
    },
}

const mutations = {
    [types.SET_IMAGE_MODAL](state, data) {
        state.imagen = data;
    },    
    [types.CHANGE_MODAL_REQUEST_CREDIT](state, data) {
        state.modal_credit = data;
    },   
    [types.SET_TYPE_CREDIT](state, data) {
        state.type = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
